import { Checkbox, TableCell } from "@mui/material";
import { type ChangeEvent, memo, useCallback } from "react";

interface RolesTableCellProps {
  name: string | undefined;
  isChecked: boolean;
  isDisabled?: boolean;
  onChange?: (ruleToChange: string, isChecked: boolean) => void;
}

export const RolesTableCell = memo(
  ({ name, isDisabled, isChecked, onChange }: RolesTableCellProps) => {
    const handleChangeRule = useCallback(
      (event: ChangeEvent<HTMLInputElement>, isChecked: boolean) => {
        const ruleToChange = event.target.name;

        if (!ruleToChange || !onChange) {
          return;
        }

        onChange(ruleToChange, isChecked);
      },
      [onChange],
    );

    return (
      <TableCell>
        <Checkbox
          name={name}
          disabled={isDisabled}
          checked={isChecked}
          onChange={handleChangeRule}
        />
      </TableCell>
    );
  },
);

RolesTableCell.displayName = "RolesTableCell";
